import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/ReportBreakDownActions";
import * as api from "../../api/ReportBreakDownApi";
import { showErrorSnackbar, showSuccessSnackbar } from "../actions/SnackbarActions";
import { resetBackdrop, setBackdrop } from "../actions/BackdropActions";

function* getBreakDownReasonGroupList() {
    try {
        const { data } = yield api.getBreakdownReasonGroupList();
        yield put(actions.setBreakdownReasonGroupList(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownReasonGroupList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownReasonEffectList() {
    yield put(resetBackdrop());

    try {
        const { data } = yield api.getBreakdownEffectList();
        yield put(actions.setBreakdownEffectList(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownEffectList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getAreaList() {
    try {
        const { data } = yield api.getAreaList();
        yield put(actions.setAreaList(data || undefined));
    } catch (error) {
        yield put(actions.setAreaList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEquipmentGetMainListByAreaID(action) {
    try {
        const { data } = yield api.getEquipmentGetMainListByAreaID(action.payload);
        yield put(actions.setEquipmentGetMainListByAreaID(data || undefined));
    } catch (error) {
        yield put(actions.setEquipmentGetMainListByAreaID(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEquipmentGetSubListById(action) {
    try {
        const { data } = yield api.getEquipmentGetSubListById(action.payload);
        yield put(actions.setEquipmentGetSubListById(data || undefined));
    } catch (error) {
        yield put(actions.setEquipmentGetSubListById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPoolList() {
    try {
        const { data } = yield api.getPoolList();
        yield put(actions.setPoolList(data || undefined));
    } catch (error) {
        yield put(actions.setPoolList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakdownReasonPlaceGetListByGroupId(action) {
    try {
        const { data } = yield api.getBreakdownReasonPlaceGetListByGroupId(action.payload);
        yield put(actions.setBreakdownReasonPlaceGetListByGroupId(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownReasonPlaceGetListByGroupId(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* postUnplannedMaintenanceCreateWithFile(action) {
    yield put(resetBackdrop());
console.log('action.payload', action.payload);
    try {
        const { data } = yield api.postUnplannedMaintenanceCreateWithFile(action.payload);
        yield put(actions.setUnplannedMaintenanceCreateWithFile(data || undefined));
        yield put(showSuccessSnackbar({ data }));
    } catch (error) {
        yield put(actions.setUnplannedMaintenanceCreateWithFile(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEquipmentGetByBarcodeContext(action) {
    try {
        const { data } = yield api.getEquipmentGetByBarcodeContext(action.payload);
        yield put(actions.setEquipmentGetByBarcodeContext(data || undefined));
    } catch (error) {
        yield put(actions.setEquipmentGetByBarcodeContext(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_BREAKDOWN_REASONGROUP_LIST, getBreakDownReasonGroupList);
    yield takeEvery(actions.Types.GET_BREAKDOWN_EFFECT_LIST, getBreakDownReasonEffectList);
    yield takeEvery(actions.Types.GET_AREA_LIST_IN_BREAKDOWN, getAreaList);
    yield takeEvery(actions.Types.GET_BREAKDOWN_EQUIPMENT_GET_MAIN_LIST_BY_AREA_ID, getEquipmentGetMainListByAreaID);
    yield takeEvery(actions.Types.GET_EQUIPMENT_GET_SUB_LIST_BY_ID, getEquipmentGetSubListById);
    yield takeEvery(actions.Types.GET_POOL_LIST_IN_BREAKDOWN, getPoolList);
    yield takeEvery(actions.Types.GET_BREAKDOWN_REASON_PLACE_GET_LIST_BY_GROUP_ID, getBreakdownReasonPlaceGetListByGroupId);
    yield takeEvery(actions.Types.POST_UNPLANNED_MAINTENANCE_CREATE_WITH_FILE, postUnplannedMaintenanceCreateWithFile);
    yield takeEvery(actions.Types.GET_EQUIPMENT_GET_BY_BARCODE_CONTEXT, getEquipmentGetByBarcodeContext);
}

const ReportBreakDownSagas = [fork(watchAll)];

export default ReportBreakDownSagas;
